export const ROLE_PETUGAS_UKUR = 1;
export const ROLE_KORLAP = 2;
export const ROLE_GRAFIS = 3;
export const ROLE_ARSIP = 3;
export const ROLE_PEMETAAN = 3;
export const ROLE_KASUBSI = 3;
export const ROLE_KOREKSI = 3;
export const ROLE_KASI = 3;
export const ROLE_LOKET = 3;

export default {
  ROLE_PETUGAS_UKUR,
  ROLE_KORLAP,
  ROLE_GRAFIS,
  ROLE_ARSIP,
  ROLE_PEMETAAN,
  ROLE_KASUBSI,
  ROLE_KOREKSI,
  ROLE_KASI,
  ROLE_LOKET
};
